'use client';
import classnames from 'classnames';
import React, { useState } from 'react';

interface TabsProperty {
  className?: string;
  tabs?: { label: string; value?: string | number }[];
  onHover?: (index: number) => void;
  onClick?: (index: number) => void;
}

export const Tabs: React.FC<TabsProperty> = ({ className, tabs, onClick, onHover }) => {
  const [current, setCurrent] = useState(0);

  const onClickTab = (index: number) => () => {
    setCurrent(index);
    onClick?.(index);
  };

  const onHoverTab = (index: number) => () => {
    setCurrent(index);
    onHover?.(index);
  };

  return (
    <ul className={classnames('flex w-full items-center text-center text-base text-[#515c69]', className)}>
      {tabs?.map((tab, index) => {
        const { label } = tab;
        const isActive = index === current;

        return (
          <li
            key={label}
            onClick={onClickTab(index)}
            onMouseOver={onHoverTab(index)}
            className={classnames(
              'relative w-full cursor-pointer after:h-[1px]',
              {
                'after:cotent-[""]  relative leading-[47px] text-[#e03f19] after:absolute after:left-1/2 after:top-0 after:block after:h-[2px] after:w-5 after:translate-x-[-50%] after:bg-[#e03f19] after:shadow-[0_2px_6px_0_rgba(222,52,45,0.5)] lg:leading-[32px] lg:after:bottom-0 lg:after:top-auto lg:after:w-full':
                  isActive
              },
              {
                'lg:after:absolute lg:after:bottom-[-4px] lg:after:left-0 lg:after:w-full lg:after:bg-[#e2e8f1] lg:after:content-[""]':
                  !isActive
              }
            )}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
};

export default Tabs;
